const styles = {
  container: {
    backgroundColor: "#eeeeee",
    border: "0.05px solid rgba(99,115,164,0.2)",
    borderRadius: "4px",
    width: "283px",
    position: "absolute",
    padding: "10px",
    paddingBottom: "5px",
    right: 0,
    top: "100px",
    boxSizing: "border-box",
    color: "#6373A4",
    maxHeight: "70vh",
    overflowY: "auto",
    zIndex: 0,
    "@media (max-width: 1200px)": {
      display: "none",
    },
  },
  title: {
    fontFamily: ({ theme }) => theme.fontFamily,
    marginTop: "20px",
    marginBottom: "10px",
  },
  stopItem: {
    backgroundColor: "#fff",
    fontFamily: ({ theme }) => theme.fontFamily,
    fontSize: "14px",
    fontWeifht: "300",
    lineHeight: "22px",
    background: "#fff",
    borderBottom: "1px solid #eeeeee",
    borderLeft: "3px solid rgb(8, 95, 229)",
    padding: "12px 10px",
    marginBottom: "3px",
  },
};

export default styles;
